import React, { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import MapComponent from '../components/MapComponent';
import Joyride from 'react-joyride';
import { Box } from '@mui/material';

import NavbarComponent from '../components/NavbarComponent';
import BottomNavigatorComponent from '../components/BottomNavigatorComponent';
import LeftNavigatorComponent from '../components/LeftNavigatorComponent';
import RightNavigatorComponent from '../components/RightNavigatorComponent';
import CoordinateInfo from '../components/CoordinateInfo';

const App = () => {
  const [runTour, setRunTour] = useState(false);
  const tourSteps = [
    {
      target: '.fg-location-arrow fg-2x',
      content: 'Bu buton işlem yapmak için kullanılır.',
      placement: 'top',
    },
  ];

  const startTour = () => {
    setRunTour(true);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        touchAction: 'none', // Sayfa seviyesinde touch event kontrolü
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* <button onClick={startTour}>Tikla</button> */}
      <Joyride
        steps={tourSteps}
        run={runTour}
        styles={{
          options: {
            arrowColor: '#e3ffeb',
            backgroundColor: '#e3ffeb',
            overlayColor: 'rgba(79, 26, 0, 0.4)',
            primaryColor: '#000',
            textColor: '#004a14',
            width: 900,
            zIndex: 1000,
          },
        }}
      />
      
      {/* Navbar - sabit yükseklik */}
      <Box sx={{ 
        flexShrink: 0,
        position: 'relative',
        zIndex: 1300,
        touchAction: 'manipulation'
      }}>
        <NavbarComponent />
      </Box>
      
      {/* Map Container - kalan alanı kapla */}
      <Box 
        sx={{ 
          flexGrow: 1,
          position: 'relative',
          overflow: 'hidden',
          touchAction: 'none' // Harita alanında touch event'ler harita tarafından yönetilsin
        }}
      >
        <MapComponent />
        <Box sx={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none', // UI elementleri dışında tüm pointer event'leri haritaya geçsin
          '& > *': {
            pointerEvents: 'auto' // Child elementlerde pointer event'leri aktif et
          }
        }}>
          <BottomNavigatorComponent />
          <LeftNavigatorComponent />
          <RightNavigatorComponent />
          <CoordinateInfo />

        </Box>
      </Box>
    </Box>
  );
};

export default App;
